import { useFlag } from '@unleash/proxy-client-react'

// The learner-facing half of coaching (ENG-3375). Its own flag, separate from
// COACH_WORKSPACE_FEATURE_FLAG, because the two are turned on for different
// people at different times: `coach-workspace` opens the tooling to a handful of
// pilot coaches, and this opens a page to the learners those coaches write to.
// Rolling the first out does not mean the second is ready, and a single flag
// would make the coach pilot visible to every learner they message.
//
// **Separate does not mean sufficient: a learner needs BOTH.** The whole coaching
// router carries REQUIRE_COACH_WORKSPACE, so `coach-workspace` is what makes the
// API answer at all and this flag is what puts a page in front of it. A learner
// given only this one gets a 404 on every coaching read and an error page for
// their trouble. Both are targeted the same way — a `userId IN` constraint
// listing the Clerk id *and* the database uuid for each person, since the
// frontend sends the first and the request path sends the second.
//
// ROUTED SURFACES MUST NOT USE THIS HOOK TO DECIDE ACCESS. Wrap them in
// <LearnerCoachingGuard> instead, for the reason spelled out on
// useCoachWorkspaceEnabled: FeatureFlagGuard is the only place that waits for
// the Clerk context push before deciding, and a hand-rolled `useFlag` +
// redirect bounces a learner off the page on every hard refresh.
//
// Use this hook only for in-page conditionals — a nav entry, a card, a CTA —
// where a transient false renders nothing rather than navigating away.
export const LEARNER_COACHING_FEATURE_FLAG = 'learner-coaching'

export function useLearnerCoachingEnabled(): boolean {
  return useFlag(LEARNER_COACHING_FEATURE_FLAG)
}
